import { render, staticRenderFns } from "./ImageLibraryRegister.vue?vue&type=template&id=23753b55"
import script from "./ImageLibraryRegister.vue?vue&type=script&lang=js"
export * from "./ImageLibraryRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports